export enum BettingMode {
    Multiple = 0,
    Independent = 1
}

export enum BetslipLayout {
    basic = 0,
    floating = 1
}